
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`List of event IDs to filter which events are to be replayed.`}</p>
    <p>{`This is an alternative to the `}<inlineCode parentName="p">{`filter`}</inlineCode>{` argument, providing the ability to replay a list of specific events by their IDs.
`}<inlineCode parentName="p">{`eventIds`}</inlineCode>{` and `}<inlineCode parentName="p">{`filter`}</inlineCode>{` cannot be specified in the same mutation.`}</p>
    <p>{`A maximum of 100 event IDs may be provided.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;